__turbopack_context__.v({
  "funnel-card": "pJgtTa_funnel-card",
  "funnel-embed-header": "pJgtTa_funnel-embed-header",
  "funnel-embed-step": "pJgtTa_funnel-embed-step",
  "headline": "pJgtTa_headline",
  "headline-and-icon": "pJgtTa_headline-and-icon",
  "icon": "pJgtTa_icon",
  "placeholder": "pJgtTa_placeholder",
  "progress": "pJgtTa_progress",
  "progress-container": "pJgtTa_progress-container",
  "progress-number": "pJgtTa_progress-number",
  "reload-cta": "pJgtTa_reload-cta",
  "root": "pJgtTa_root",
  "sub-headline": "pJgtTa_sub-headline",
});
